import React from 'react'
import userStoredData from '../userStoredData'
import { Navigate, useParams } from 'react-router-dom'

export default function TokenLogin() {
  const { token } = useParams()
  userStoredData.setToken(token)
  return <Navigate to={`/`} replace />
}
